import { useSelector } from 'react-redux'
import { Stack } from '@leroy-merlin-br/backyard-react-ui'
import PropTypes from 'prop-types'

import { Spinner } from 'reactGarden/Spinner'

import * as S from './styled'

const Footer = ({
  text,
  isActive,
  isDisabled,
  isLoading,
  currentStep,
  prev,
  next,
  onSubmit,
  toggleModalError,
  hasClients,
  price,
  customerSelected
}) => {
  const { isRequest } = useSelector((state) => state.coupon.shareable)

  if (currentStep === 3) {
    return (
      <S.Content isActive={isActive}>
        <Stack spacing="kilo">
          <S.ButtonSend
            color="green"
            isLoading={isRequest}
            isStretch
            onClick={onSubmit}
          >
            {isRequest ? <Spinner /> : `${price} Pts`}
          </S.ButtonSend>

          <S.ButtonSend
            color="green"
            variant="ghost"
            isDisabled={isRequest}
            isStretch
            onClick={prev}
          >
            voltar
          </S.ButtonSend>
        </Stack>
      </S.Content>
    )
  }

  if (currentStep > 1) {
    return (
      <S.Content isActive={isActive}>
        <Stack spacing="kilo">
          <S.ButtonSend
            color="green"
            isDisabled={!customerSelected}
            isStretch
            onClick={next}
          >
            {isLoading ? <Spinner /> : 'Continuar'}
          </S.ButtonSend>

          <S.ButtonSend color="green" variant="ghost" isStretch onClick={prev}>
            voltar
          </S.ButtonSend>
        </Stack>
      </S.Content>
    )
  }

  return (
    <S.Content isActive={isActive}>
      {text && (
        <S.TextFooter size="kilo" align="center">
          {text}
        </S.TextFooter>
      )}

      <S.ButtonSend
        color="green"
        isDisabled={isDisabled}
        isStretch
        onClick={hasClients ? next : toggleModalError}
      >
        Compartilhar
      </S.ButtonSend>
    </S.Content>
  )
}

Footer.propTypes = {
  text: PropTypes.node,
  textFooter: PropTypes.node,
  buttonText: PropTypes.shape({
    default: PropTypes.string,
    active: PropTypes.string
  }),
  isActive: PropTypes.bool,
  isLoading: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func
}

Footer.defaultProps = {
  buttonText: {
    default: 'Ativar',
    active: 'Ativado'
  }
}

export default Footer
